'use strict';

export default angular
  .module('maestro.filters.challengeType', [])

  .filter('challengeType', function(utils) {
    return function(challenge) {
      return utils.getChallengeType(challenge);
    };
  })

  .name;
